import { render } from "./TransferList.vue?vue&type=template&id=1763daa4&scoped=true"
import script from "./TransferList.vue?vue&type=script&lang=js"
export * from "./TransferList.vue?vue&type=script&lang=js"

import "./TransferList.vue?vue&type=style&index=0&id=1763daa4&scoped=true&lang=css"
import "./TransferList.vue?vue&type=style&index=1&id=1763daa4&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1763daa4"]])

export default __exports__